import React from 'react';
import { Row, Col } from 'reactstrap';
import i18n from "i18n-react";
import ActionButton from '../ActionsBuitton/ActionButton';
import * as FaIcons from "react-icons/fa";
import PropTypes from 'prop-types';

const BulkActionsBar = ({
    selectedCount,
    checkAll,
    onToggleAll,
    actions,
    totalImages
}) => {
    const hasSelection = selectedCount > 0;

    return (
        <div className="bulk-actions-wrapper p-2 mb-3 bg-light border rounded shadow-sm">
            <Row className="align-items-center g-2">
                {/* Selector Izquierdo */}
                <Col xs={12} lg={4} className="d-flex align-items-center justify-content-lg-start">
                    <div className="d-flex align-items-center ms-2">
                        <label className="d-inline-flex align-items-center" style={{ cursor: 'pointer' }}>
                            <input
                                type="checkbox"
                                checked={checkAll}
                                onChange={onToggleAll}
                                className="form-check-input mt-0"
                            />
                            <span className="ms-2 fw-bold text-secondary">
                                {i18n.translate("default_all")}
                            </span>
                        </label>
                    </div>
                    <div className="d-flex align-items-center border-start ps-3 ms-3" style={{ borderColor: '#dee2e6' }}>
                        <span className="badge rounded-pill bg-secondary text-white px-2.5 py-1.5 d-flex align-items-center gap-1" style={{ fontSize: '11px', fontWeight: '500' }}>
                            <FaIcons.FaImages size={12} className="me-1" />
                            <span>
                                {totalImages || 0} {totalImages === 1 ? i18n.translate("total_archive") : i18n.translate("total_archives")}
                            </span>
                        </span>
                    </div>
                    {hasSelection && (
                        <span className="badge rounded-pill bg-primary ms-3">
                            {selectedCount} {i18n.translate("image_selected")}
                        </span>
                    )}
                </Col>

                {/* Botones Derecha */}
                <Col xs={12} lg={8}>
                    <div className="d-flex flex-wrap justify-content-center justify-content-lg-end gap-2">
                        <ActionButton
                            icon="FaDownload"
                            label={i18n.translate("default_download_all")}
                            variant="outline-secondary"
                            onClick={actions.downloadAll}
                        />

                        {hasSelection && (
                            <>
                                <ActionButton
                                    icon="FaDownload"
                                    label={i18n.translate("default_download")}
                                    variant="primary"
                                    onClick={actions.downloadSelected}
                                />
                                <ActionButton
                                    icon="FaTrash"
                                    label={i18n.translate("delete")}
                                    variant="danger"
                                    onClick={actions.deleteSelected}
                                />
                                <ActionButton
                                    icon="FaWindowClose"
                                    label={i18n.translate("cancel")}
                                    variant="secondary"
                                    onClick={actions.cancel}
                                />
                            </>
                        )}
                    </div>
                </Col>
            </Row>
        </div>
    );
};

BulkActionsBar.propTypes = {
    selectedCount: PropTypes.number.isRequired,
    totalImages: PropTypes.number.isRequired,
    checkAll: PropTypes.bool,
    onToggleAll: PropTypes.func.isRequired,
    actions: PropTypes.shape({
        downloadAll: PropTypes.func.isRequired,
        downloadSelected: PropTypes.func.isRequired,
        deleteSelected: PropTypes.func.isRequired,
        cancel: PropTypes.func.isRequired
    }).isRequired
};

export default BulkActionsBar;